import { useQuery } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import type { BracketMatchResponse } from "@bw/shared/types/generated";
import { queryKeys } from "../../../common/query/queryClient";

/**
 * A knockout-capable draw's PUBLIC bracket (GET
 * /tournaments/draws/{id}/bracket → BracketMatchResponse[], anonymous-readable).
 * Its OWN query is mounted only by a selected knockout-capable detail. The page
 * renders each match's entrants + score VERBATIM — no uuid leaks, no
 * client-side derivation. Places play-out groups the returned server-owned
 * phase/round coordinates only for bounded navigation.
 */
export function useDrawBracket(drawId: string | undefined) {
  return useQuery<BracketMatchResponse[]>({
    queryKey: queryKeys.tournaments.bracket(drawId ?? ""),
    queryFn: () => tournamentApi.getBracket(drawId as string),
    enabled: Boolean(drawId),
  });
}
